export default "__VITE_ASSET__CYqWIFFi__ 640w, __VITE_ASSET__CnwEjrc7__ 1024w, __VITE_ASSET__a5DnFCIC__ 1536w";